var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _path11, _path12, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfettiBg = function SvgConfettiBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1890,
    height: 318,
    fill: "none",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    fillRule: "evenodd",
    d: "M944.013 114.382q.46-.162.919-.344c1.896-.757 3.805-1.706 4.621-3.202 1.636-2.997.475-5.081-.503-5.678-.979-.598-3.264-.62-4.899 2.378-.817 1.496-.64 3.722-.312 5.842q.078.506.174 1.004m-6.031 1.489c-1.243.17-2.123 1.375-1.963 2.691s1.299 2.247 2.543 2.078c0 0 .901-.123 2.258-.413.442 1.398.794 2.293.794 2.293.481 1.225 1.812 1.805 2.97 1.295 1.157-.51 1.706-1.919 1.224-3.143 0 0-.25-.634-.581-1.652q.654-.223 1.307-.484c2.942-1.173 5.688-2.975 6.954-5.296 3.573-6.548-.029-10.94-2.166-12.246s-7.533-2.41-11.106 4.138c-1.266 2.319-1.37 5.738-.861 9.023q.112.723.255 1.427c-.991.203-1.628.289-1.628.289",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5838C",
    fillRule: "evenodd",
    d: "M152.326 101.386q.363-.128.726-.273c1.497-.599 3.004-1.35 3.648-2.534 1.292-2.373.375-4.023-.397-4.496-.773-.473-2.577-.49-3.868 1.883-.645 1.184-.506 2.947-.247 4.625q.063.4.138.795m-4.761 1.179c-.982.134-1.676 1.088-1.55 2.13s1.026 1.779 2.007 1.645c0 0 .712-.097 1.783-.327.349 1.107.627 1.815.627 1.815.38.97 1.431 1.429 2.345 1.026.913-.404 1.346-1.519.966-2.489 0 0-.197-.502-.459-1.308q.517-.177 1.033-.383c2.322-.929 4.49-2.355 5.489-4.192 2.821-5.184-.023-8.661-1.71-9.695s-5.947-1.909-8.768 3.276c-.999 1.836-1.081 4.542-.679 7.143q.089.572.201 1.13c-.782.16-1.285.229-1.285.229",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    fillRule: "evenodd",
    d: "M1405.01 128.382c.31-.108.62-.223.92-.344 1.9-.757 3.81-1.706 4.62-3.202 1.64-2.997.48-5.081-.5-5.678-.98-.598-3.26-.62-4.9 2.378-.82 1.496-.64 3.722-.31 5.842.05.337.11.672.17 1.004m-6.03 1.489c-1.24.17-2.12 1.375-1.96 2.691s1.3 2.247 2.54 2.078c0 0 .9-.123 2.26-.413.44 1.398.79 2.293.79 2.293.49 1.225 1.82 1.805 2.97 1.295 1.16-.51 1.71-1.919 1.23-3.143 0 0-.25-.634-.58-1.652.43-.149.87-.31 1.3-.484 2.95-1.173 5.69-2.975 6.96-5.296 3.57-6.548-.03-10.94-2.17-12.246s-7.53-2.411-11.1 4.138c-1.27 2.319-1.37 5.738-.86 9.023.07.481.16.959.25 1.427-.99.203-1.63.289-1.63.289",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5838C",
    fillRule: "evenodd",
    d: "M1737.16 210.618c-.3.108-.61.223-.91.344-1.9.757-3.81 1.706-4.63 3.202-1.63 2.997-.47 5.081.51 5.678.98.598 3.26.62 4.9-2.378.81-1.496.64-3.722.31-5.842q-.075-.506-.18-1.004m6.04-1.489c1.24-.17 2.12-1.375 1.96-2.691s-1.3-2.247-2.54-2.078c0 0-.9.123-2.26.413-.44-1.398-.8-2.293-.8-2.293-.48-1.225-1.81-1.805-2.97-1.295-1.15.51-1.7 1.919-1.22 3.143 0 0 .25.634.58 1.652-.43.149-.87.31-1.31.484-2.94 1.173-5.68 2.975-6.95 5.296-3.57 6.548.03 10.94 2.17 12.246 2.13 1.306 7.53 2.411 11.1-4.138 1.27-2.319 1.37-5.738.86-9.023-.07-.481-.16-.959-.25-1.427.99-.203 1.63-.289 1.63-.289M1229.16 191.618c-.3.108-.61.223-.91.344-1.9.757-3.81 1.706-4.63 3.202-1.63 2.997-.47 5.081.51 5.678.98.598 3.26.62 4.9-2.378.81-1.496.64-3.722.31-5.842q-.075-.506-.18-1.004m6.04-1.489c1.24-.17 2.12-1.375 1.96-2.691s-1.3-2.247-2.54-2.078c0 0-.9.123-2.26.413-.44-1.398-.8-2.293-.8-2.293-.48-1.225-1.81-1.805-2.97-1.295-1.15.51-1.7 1.919-1.22 3.143 0 0 .25.634.58 1.652-.43.149-.87.31-1.31.484-2.94 1.173-5.68 2.975-6.95 5.296-3.57 6.548.03 10.94 2.17 12.246 2.13 1.306 7.53 2.411 11.1-4.138 1.27-2.319 1.37-5.738.86-9.023-.07-.481-.16-.959-.25-1.427.99-.203 1.63-.289 1.63-.289",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    fillRule: "evenodd",
    d: "M789.165 202.618q-.46.162-.919.344c-1.896.757-3.805 1.706-4.621 3.202-1.636 2.997-.475 5.081.503 5.678.979.598 3.264.62 4.899-2.378.817-1.496.641-3.722.313-5.842a30 30 0 0 0-.175-1.004m6.031-1.489c1.244-.17 2.123-1.375 1.964-2.691-.161-1.316-1.3-2.247-2.544-2.078 0 0-.901.123-2.258.413-.441-1.398-.793-2.293-.793-2.293-.482-1.225-1.813-1.805-2.971-1.295-1.157.51-1.705 1.919-1.223 3.143 0 0 .249.634.58 1.652q-.653.223-1.307.484c-2.942 1.173-5.688 2.975-6.954 5.296-3.573 6.548.03 10.94 2.166 12.246s7.533 2.411 11.106-4.138c1.266-2.319 1.37-5.738.861-9.023q-.112-.723-.255-1.427c.991-.203 1.628-.289 1.628-.289",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5838C",
    fillRule: "evenodd",
    d: "M528.517 87.813a17 17 0 0 0-.628.243c-1.298.537-2.604 1.209-3.162 2.268-1.12 2.124-.325 3.6.344 4.023.67.423 2.233.439 3.352-1.685.559-1.06.438-2.637.214-4.138q-.054-.358-.12-.712m4.127-1.055c.851-.12 1.452-.974 1.343-1.906s-.889-1.592-1.74-1.472c0 0-.616.087-1.545.293-.302-.99-.543-1.625-.543-1.625-.329-.867-1.24-1.278-2.032-.917s-1.167 1.36-.837 2.227c0 0 .17.448.397 1.17q-.447.158-.895.342c-2.013.831-3.891 2.108-4.758 3.752-2.444 4.638.021 7.749 1.483 8.674s5.154 1.708 7.598-2.931c.866-1.643.937-4.065.589-6.391q-.077-.513-.174-1.012a18 18 0 0 1 1.114-.204",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD149",
    fillRule: "evenodd",
    d: "M807.016 237.955s-1.457-3.246-4.06-6.205c-1.85-2.103-4.275-4.026-7.107-4.745-1.152-.293-2.413.43-2.814 1.615-.4 1.184.21 2.383 1.362 2.676 2.065.525 3.775 2.008 5.124 3.542 2.197 2.497 3.434 5.232 3.434 5.232.483 1.072 1.784 1.467 2.905.884s1.638-1.928 1.156-2.999M371.461 262.46s-3.512.567-7.043 2.315c-2.511 1.243-4.996 3.088-6.424 5.637-.581 1.037-.208 2.442.832 3.136 1.04.693 2.357.414 2.938-.623 1.041-1.858 2.916-3.126 4.747-4.032 2.981-1.476 5.943-1.963 5.943-1.963 1.16-.189 1.879-1.344 1.605-2.578s-1.438-2.081-2.598-1.892M15.016 184.955s-1.457-3.246-4.06-6.205c-1.85-2.103-4.275-4.026-7.107-4.745-1.152-.293-2.413.43-2.814 1.615-.4 1.184.21 2.383 1.362 2.676 2.065.525 3.775 2.008 5.124 3.542 2.197 2.497 3.434 5.232 3.434 5.232.483 1.072 1.784 1.467 2.905.884s1.638-1.928 1.156-2.999M1268.02 219.955s-1.46-3.246-4.06-6.205c-1.85-2.103-4.28-4.026-7.11-4.745-1.15-.293-2.41.43-2.81 1.615-.41 1.184.2 2.383 1.36 2.676 2.06.525 3.77 2.008 5.12 3.542 2.2 2.497 3.43 5.232 3.43 5.232.49 1.072 1.79 1.467 2.91.884s1.64-1.928 1.16-2.999M1874.16 107.045s1.46 3.246 4.06 6.205c1.85 2.103 4.28 4.026 7.11 4.745 1.15.293 2.41-.43 2.81-1.615.4-1.184-.21-2.383-1.36-2.676-2.06-.525-3.77-2.008-5.12-3.542-2.2-2.497-3.44-5.232-3.44-5.232-.48-1.072-1.78-1.467-2.9-.884s-1.64 1.928-1.16 2.999M1400.16 78.045s1.46 3.246 4.06 6.205c1.85 2.103 4.28 4.026 7.11 4.745 1.15.293 2.41-.43 2.81-1.615.4-1.184-.21-2.383-1.36-2.676-2.06-.525-3.77-2.008-5.12-3.542-2.2-2.498-3.44-5.232-3.44-5.232-.48-1.072-1.78-1.467-2.9-.884s-1.64 1.928-1.16 3M926.162 79.045s1.458 3.246 4.06 6.205c1.85 2.103 4.275 4.026 7.107 4.745 1.152.293 2.413-.43 2.814-1.615.401-1.184-.21-2.383-1.362-2.676-2.064-.525-3.774-2.008-5.124-3.542-2.197-2.498-3.434-5.232-3.434-5.232-.483-1.072-1.784-1.467-2.905-.884s-1.638 1.928-1.156 3M624.162 66.045s1.458 3.246 4.06 6.205c1.85 2.103 4.275 4.026 7.107 4.745 1.152.293 2.413-.43 2.814-1.615.401-1.184-.21-2.383-1.362-2.676-2.064-.525-3.774-2.008-5.124-3.542-2.197-2.498-3.434-5.232-3.434-5.232-.483-1.072-1.784-1.467-2.905-.884s-1.638 1.928-1.156 3",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#54568C",
    fillRule: "evenodd",
    d: "M1135.35 209.71s-.27-2.714.32-5.679c.37-1.82 1.04-3.764 2.42-5.116.78-.754.71-1.975-.14-2.725s-2.18-.747-2.95.008c-1.9 1.853-2.94 4.468-3.44 6.964-.7 3.512-.37 6.728-.37 6.728.11 1.063 1.12 1.885 2.27 1.836 1.15-.05 1.99-.953 1.89-2.016M690.346 236.71s-.269-2.714.325-5.679c.365-1.82 1.037-3.764 2.423-5.116.774-.754.71-1.975-.144-2.725s-2.175-.747-2.949.008c-1.901 1.853-2.936 4.468-3.437 6.964-.704 3.512-.376 6.728-.376 6.728.107 1.063 1.125 1.885 2.273 1.836 1.147-.05 1.992-.953 1.885-2.016M343.346 166.71s-.269-2.714.325-5.679c.365-1.82 1.037-3.764 2.423-5.116.774-.754.71-1.975-.144-2.725s-2.175-.747-2.949.008c-1.901 1.853-2.936 4.468-3.437 6.964-.704 3.512-.376 6.728-.376 6.728.107 1.063 1.125 1.885 2.273 1.836 1.147-.05 1.992-.953 1.885-2.016M1596.35 193.71s-.27-2.714.32-5.679c.37-1.82 1.04-3.764 2.42-5.116.78-.754.71-1.975-.14-2.725s-2.18-.747-2.95.008c-1.9 1.853-2.94 4.468-3.44 6.964-.7 3.512-.37 6.728-.37 6.728.11 1.063 1.12 1.885 2.27 1.836 1.15-.05 1.99-.953 1.89-2.016M1071.83 96.29s.27 2.714-.32 5.679c-.37 1.82-1.04 3.764-2.43 5.116-.77.754-.71 1.975.15 2.725.85.75 2.17.747 2.95-.008 1.9-1.853 2.93-4.468 3.43-6.964.71-3.511.38-6.728.38-6.728-.11-1.063-1.13-1.885-2.27-1.836-1.15.05-1.99.953-1.89 2.016M597.832 107.29s.269 2.714-.325 5.679c-.365 1.82-1.037 3.764-2.423 5.116-.774.754-.709 1.975.144 2.725.854.75 2.175.747 2.949-.008 1.901-1.853 2.937-4.468 3.437-6.964.704-3.512.376-6.728.376-6.728-.107-1.063-1.125-1.885-2.273-1.836-1.147.05-1.991.953-1.885 2.016M295.832 84.29s.269 2.714-.325 5.679c-.365 1.82-1.037 3.764-2.423 5.116-.774.754-.709 1.975.144 2.725.854.75 2.175.747 2.949-.008 1.901-1.853 2.937-4.468 3.437-6.964.704-3.511.376-6.728.376-6.728-.107-1.063-1.125-1.885-2.273-1.836-1.147.05-1.991.953-1.885 2.016",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD149",
    fillRule: "evenodd",
    d: "M1188.61 237.637s1.24-2.735 3.44-5.233c1.35-1.534 3.06-3.017 5.12-3.542 1.15-.293 1.76-1.492 1.36-2.676s-1.66-1.908-2.81-1.615c-2.83.719-5.26 2.642-7.11 4.746-2.6 2.958-4.06 6.204-4.06 6.204-.48 1.071.04 2.415 1.16 2.999s2.42.188 2.9-.883M743.612 264.637s1.237-2.735 3.434-5.233c1.349-1.534 3.059-3.017 5.124-3.542 1.152-.293 1.762-1.492 1.361-2.676-.4-1.185-1.661-1.908-2.814-1.615-2.831.719-5.256 2.642-7.106 4.746-2.603 2.958-4.06 6.204-4.06 6.204-.482 1.071.035 2.415 1.156 2.999s2.422.188 2.905-.883M1649.61 221.637s1.24-2.735 3.44-5.233c1.35-1.534 3.06-3.017 5.12-3.542 1.15-.293 1.76-1.492 1.36-2.676s-1.66-1.908-2.81-1.615c-2.83.719-5.26 2.642-7.11 4.746-2.6 2.958-4.06 6.204-4.06 6.204-.48 1.071.04 2.415 1.16 2.999s2.42.188 2.9-.883M1551.95 104.067s-1.23 2.735-3.43 5.232c-1.35 1.534-3.06 3.017-5.12 3.542-1.16.293-1.77 1.492-1.36 2.676.4 1.185 1.66 1.908 2.81 1.615 2.83-.719 5.26-2.642 7.11-4.745 2.6-2.959 4.06-6.205 4.06-6.205.48-1.071-.04-2.415-1.16-2.999-1.12-.583-2.42-.188-2.91.884M1018.57 68.364s-1.24 2.734-3.44 5.232c-1.35 1.534-3.06 3.017-5.12 3.542-1.15.293-1.76 1.492-1.36 2.676s1.66 1.908 2.81 1.615c2.83-.72 5.26-2.642 7.11-4.746 2.6-2.958 4.06-6.204 4.06-6.204.48-1.071-.04-2.415-1.16-2.999s-2.42-.188-2.9.883M242.566 56.364s-1.237 2.734-3.434 5.232c-1.349 1.534-3.059 3.017-5.124 3.542-1.152.293-1.762 1.492-1.361 2.676s1.661 1.908 2.814 1.615c2.831-.72 5.256-2.642 7.106-4.746 2.603-2.958 4.06-6.204 4.06-6.204.483-1.071-.035-2.415-1.156-2.999-1.12-.583-2.422-.188-2.905.884",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#54568C",
    fillRule: "evenodd",
    d: "M930.959 243.588a18 18 0 0 0-.713-.174c-1.489-.332-3.064-.553-4.18.015-2.238 1.137-2.362 2.886-1.995 3.657.366.772 1.781 1.738 4.019.601 1.117-.568 1.912-1.993 2.569-3.416q.158-.34.3-.683m4.363 1.612c.843.416 1.881.052 2.317-.814.435-.866.104-1.906-.74-2.322 0 0-.611-.302-1.575-.692.294-1.033.438-1.723.438-1.723.198-.944-.396-1.852-1.324-2.025s-1.843.453-2.04 1.397c0 0-.103.489-.31 1.245q-.499-.137-1.011-.252c-2.31-.515-4.753-.566-6.486.314-4.888 2.485-4.429 6.654-3.628 8.338.8 1.684 3.713 4.607 8.601 2.122 1.732-.88 3.186-2.912 4.204-5.118q.225-.487.422-.973c.699.29 1.132.503 1.132.503",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#54568C",
    fillRule: "evenodd",
    d: "M485.959 270.588a18 18 0 0 0-.713-.174c-1.489-.332-3.064-.553-4.18.015-2.238 1.137-2.362 2.886-1.995 3.657.366.772 1.781 1.738 4.019.601 1.117-.568 1.912-1.993 2.569-3.416q.157-.34.3-.683m4.363 1.612c.843.416 1.881.052 2.317-.814.435-.866.104-1.906-.74-2.322 0 0-.611-.302-1.575-.692.294-1.033.438-1.723.438-1.723.198-.944-.396-1.852-1.324-2.025s-1.843.453-2.04 1.397c0 0-.103.489-.31 1.245q-.499-.137-1.011-.252c-2.31-.515-4.753-.566-6.486.314-4.888 2.485-4.429 6.654-3.628 8.338.8 1.684 3.713 4.607 8.601 2.122 1.732-.88 3.186-2.912 4.204-5.118q.225-.487.422-.973c.699.29 1.132.503 1.132.503M138.959 200.588a18 18 0 0 0-.713-.174c-1.489-.332-3.064-.553-4.18.015-2.238 1.137-2.362 2.886-1.995 3.657.366.772 1.781 1.738 4.019.601 1.117-.568 1.912-1.993 2.569-3.416q.157-.34.3-.683m4.363 1.612c.843.416 1.881.052 2.317-.814.435-.866.104-1.906-.74-2.322 0 0-.611-.302-1.575-.692.294-1.033.438-1.723.438-1.723.198-.944-.396-1.852-1.324-2.025s-1.843.453-2.04 1.397c0 0-.103.489-.31 1.245q-.499-.137-1.011-.252c-2.31-.515-4.753-.566-6.486.314-4.888 2.485-4.429 6.654-3.628 8.338.8 1.684 3.713 4.607 8.601 2.122 1.732-.88 3.186-2.912 4.204-5.118q.225-.487.422-.973c.699.29 1.132.503 1.132.503M1391.96 227.588c-.24-.062-.47-.121-.71-.174-1.49-.332-3.07-.553-4.18.015-2.24 1.137-2.37 2.886-2 3.657.37.772 1.78 1.738 4.02.601 1.12-.568 1.91-1.993 2.57-3.416zm4.36 1.612c.85.416 1.88.052 2.32-.814.43-.866.1-1.906-.74-2.322 0 0-.61-.302-1.58-.692.3-1.033.44-1.723.44-1.723.2-.944-.39-1.852-1.32-2.025s-1.84.453-2.04 1.397c0 0-.1.489-.31 1.245-.33-.091-.67-.176-1.01-.252-2.31-.515-4.76-.566-6.49.314-4.89 2.485-4.43 6.654-3.63 8.338s3.72 4.607 8.6 2.122c1.74-.88 3.19-2.912 4.21-5.118q.225-.487.42-.973c.7.29 1.13.503 1.13.503M1750.22 81.412c.23.062.47.12.71.174 1.49.332 3.07.553 4.18-.015 2.24-1.137 2.36-2.886 2-3.657-.37-.772-1.78-1.738-4.02-.6-1.12.567-1.91 1.992-2.57 3.415q-.165.34-.3.683m-4.36-1.612c-.85-.416-1.88-.052-2.32.814-.44.865-.1 1.906.74 2.322 0 0 .61.302 1.57.691-.29 1.034-.43 1.724-.43 1.724-.2.944.39 1.852 1.32 2.025s1.84-.453 2.04-1.397c0 0 .1-.489.31-1.245.33.09.67.175 1.01.252 2.31.515 4.75.566 6.49-.314 4.88-2.485 4.43-6.654 3.63-8.338-.81-1.684-3.72-4.606-8.61-2.122-1.73.88-3.18 2.912-4.2 5.118q-.225.487-.42.973c-.7-.29-1.13-.503-1.13-.503M1276.22 62.412c.23.062.47.12.71.174 1.49.332 3.07.553 4.18-.015 2.24-1.137 2.36-2.886 2-3.657-.37-.772-1.78-1.738-4.02-.6-1.12.567-1.91 1.992-2.57 3.415q-.165.34-.3.683m-4.36-1.612c-.85-.416-1.88-.052-2.32.814s-.1 1.906.74 2.322c0 0 .61.302 1.57.691-.29 1.034-.43 1.724-.43 1.724-.2.944.39 1.852 1.32 2.025s1.84-.453 2.04-1.397c0 0 .1-.489.31-1.245.33.09.67.175 1.01.252 2.31.515 4.75.566 6.49-.314 4.88-2.485 4.43-6.654 3.63-8.338-.81-1.684-3.72-4.607-8.61-2.122-1.73.88-3.18 2.912-4.2 5.118q-.225.487-.42.973c-.7-.29-1.13-.503-1.13-.503M802.22 73.412q.351.093.712.174c1.489.332 3.064.553 4.181-.015 2.237-1.137 2.361-2.886 1.995-3.657-.367-.772-1.782-1.738-4.02-.6-1.117.567-1.912 1.992-2.569 3.415q-.157.34-.299.683m-4.363-1.612c-.844-.416-1.882-.052-2.318.814-.435.865-.103 1.906.74 2.322 0 0 .612.302 1.575.691-.294 1.034-.438 1.724-.438 1.724-.198.944.396 1.852 1.324 2.025.929.173 1.843-.453 2.04-1.397 0 0 .103-.489.31-1.245q.499.136 1.011.252c2.311.515 4.754.566 6.486-.314 4.888-2.485 4.429-6.654 3.628-8.338-.8-1.684-3.713-4.607-8.601-2.122-1.731.88-3.186 2.912-4.204 5.118q-.224.487-.422.973c-.699-.29-1.131-.503-1.131-.503",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8BED0",
    fillRule: "evenodd",
    d: "M964.903 65.074q.351.093.712.174c1.489.332 3.064.553 4.181-.015 2.238-1.137 2.361-2.886 1.995-3.657s-1.782-1.738-4.019-.6c-1.118.567-1.913 1.992-2.57 3.415q-.157.34-.299.683m-4.363-1.612c-.844-.416-1.882-.052-2.317.814s-.104 1.906.739 2.322c0 0 .612.302 1.575.692-.293 1.033-.438 1.723-.438 1.723-.198.944.396 1.852 1.324 2.025.929.174 1.843-.453 2.041-1.397 0 0 .102-.489.309-1.245q.498.136 1.012.252c2.31.515 4.753.566 6.485-.314 4.888-2.485 4.429-6.654 3.629-8.338s-3.713-4.606-8.602-2.122c-1.731.88-3.186 2.912-4.204 5.118q-.224.487-.422.974c-.699-.29-1.131-.504-1.131-.504",
    clipRule: "evenodd",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.837 189a9.83 9.83 0 0 0-9.088 6.072 9.83 9.83 0 0 0 2.132 10.72 9.84 9.84 0 0 0 5.037 2.693 9.84 9.84 0 0 0 10.098-4.183A9.838 9.838 0 0 0 898.837 189m0 18.614a8.74 8.74 0 0 1-8.083-5.401 8.74 8.74 0 0 1 1.897-9.535 8.74 8.74 0 0 1 4.479-2.394 8.755 8.755 0 0 1 8.982 3.72 8.75 8.75 0 0 1 1.474 4.861 8.756 8.756 0 0 1-8.749 8.749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.838 191.35a7.49 7.49 0 0 0-6.915 4.62 7.48 7.48 0 0 0 1.622 8.156 7.49 7.49 0 0 0 8.157 1.623 7.488 7.488 0 0 0 0-13.831 7.5 7.5 0 0 0-2.864-.568m0 13.907a6.397 6.397 0 0 1-4.523-10.917 6.396 6.396 0 1 1 4.523 10.917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.836 194.129a4.738 4.738 0 0 0-3.349 8.086 4.738 4.738 0 0 0 8.086-3.349 4.74 4.74 0 0 0-4.737-4.737m0 8.356a3.65 3.65 0 0 1-3.372-2.253 3.651 3.651 0 0 1 4.769-4.77 3.66 3.66 0 0 1 2.254 3.373 3.663 3.663 0 0 1-3.651 3.65"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.205 232.936a9.835 9.835 0 0 0-6.956 16.792 9.83 9.83 0 0 0 10.72 2.132 9.83 9.83 0 0 0 6.073-9.088 9.837 9.837 0 0 0-9.837-9.836m0 18.613a8.749 8.749 0 1 1 8.749-8.748 8.756 8.756 0 0 1-8.749 8.748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.206 235.285a7.483 7.483 0 0 0-5.293 12.777 7.48 7.48 0 0 0 8.157 1.622 7.48 7.48 0 0 0 4.62-6.914 7.47 7.47 0 0 0-2.191-5.294 7.48 7.48 0 0 0-5.293-2.191m0 13.908a6.39 6.39 0 0 1-5.909-3.948 6.394 6.394 0 1 1 5.909 3.948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.204 238.064a4.73 4.73 0 0 0-4.376 2.924 4.74 4.74 0 0 0 3.452 6.459 4.74 4.74 0 0 0 5.661-4.646 4.745 4.745 0 0 0-4.737-4.737m0 8.357a3.653 3.653 0 0 1-3.58-4.363 3.66 3.66 0 0 1 2.868-2.868 3.65 3.65 0 0 1 4.363 3.58 3.665 3.665 0 0 1-3.651 3.651"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.532 133a6.53 6.53 0 0 0-6.406 7.807 6.531 6.531 0 1 0 6.406-7.807m0 12.361a5.808 5.808 0 0 1-5.698-6.944 5.815 5.815 0 0 1 4.565-4.565 5.81 5.81 0 1 1 1.133 11.509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.533 134.561a4.971 4.971 0 1 0 1.902 9.562 4.98 4.98 0 0 0 3.068-4.592 4.97 4.97 0 0 0-4.97-4.97m0 9.235a4.248 4.248 0 1 1 0-8.495 4.248 4.248 0 0 1 0 8.495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.532 136.406a3.147 3.147 0 0 0-.614 6.231 3.147 3.147 0 0 0 3.759-3.085 3.15 3.15 0 0 0-3.145-3.146m0 5.549a2.43 2.43 0 0 1-2.24-1.496 2.429 2.429 0 0 1 1.767-3.305 2.417 2.417 0 0 1 2.488 1.031c.266.398.409.867.409 1.346a2.436 2.436 0 0 1-2.424 2.424"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1361.2 189.936c-1.94 0-3.84.576-5.46 1.657a9.8 9.8 0 0 0-3.62 4.415 9.8 9.8 0 0 0-.56 5.683 9.8 9.8 0 0 0 2.69 5.037 9.85 9.85 0 0 0 5.04 2.692 9.83 9.83 0 0 0 10.09-4.183 9.84 9.84 0 0 0 1.66-5.465 9.835 9.835 0 0 0-9.84-9.836m0 18.613c-1.73 0-3.42-.513-4.86-1.474a8.8 8.8 0 0 1-3.22-3.927 8.83 8.83 0 0 1-.5-5.055 8.8 8.8 0 0 1 2.4-4.48 8.738 8.738 0 0 1 9.53-1.896 8.75 8.75 0 0 1 3.93 3.223 8.756 8.756 0 0 1-1.09 11.045 8.76 8.76 0 0 1-6.19 2.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.21 192.285a7.49 7.49 0 0 0-6.92 4.62 7.45 7.45 0 0 0-.42 4.325 7.46 7.46 0 0 0 5.88 5.88c1.45.289 2.95.141 4.32-.426a7.46 7.46 0 0 0 3.36-2.756 7.5 7.5 0 0 0 1.26-4.158c0-.983-.19-1.957-.57-2.865a7.45 7.45 0 0 0-4.05-4.051 7.5 7.5 0 0 0-2.86-.569m0 13.908a6.4 6.4 0 0 1-3.56-1.078 6.37 6.37 0 0 1-2.35-2.87 6.4 6.4 0 0 1-.37-3.695c.25-1.241.86-2.38 1.75-3.275a6.44 6.44 0 0 1 3.28-1.75 6.4 6.4 0 0 1 3.69.364 6.38 6.38 0 0 1 2.87 2.355 6.34 6.34 0 0 1 1.08 3.553 6.39 6.39 0 0 1-6.39 6.396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.2 195.064a4.728 4.728 0 0 0-4.37 2.924 4.75 4.75 0 0 0-.27 2.737c.18.919.63 1.763 1.3 2.425.66.663 1.5 1.114 2.42 1.297s1.87.089 2.74-.27a4.74 4.74 0 0 0 2.92-4.376c0-1.255-.5-2.459-1.39-3.347a4.75 4.75 0 0 0-3.35-1.39m0 8.357a3.63 3.63 0 0 1-2.02-.615 3.7 3.7 0 0 1-1.35-1.639 3.7 3.7 0 0 1-.21-2.109c.15-.708.49-1.358 1-1.869a3.65 3.65 0 0 1 3.98-.791 3.63 3.63 0 0 1 2.25 3.372 3.62 3.62 0 0 1-1.07 2.578 3.66 3.66 0 0 1-2.58 1.073"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1780.97 119.064c1.95 0 3.85-.576 5.47-1.657a9.8 9.8 0 0 0 3.62-4.415c.75-1.797.94-3.775.56-5.683a9.9 9.9 0 0 0-2.69-5.037 9.85 9.85 0 0 0-5.04-2.692 9.8 9.8 0 0 0-5.68.56 9.9 9.9 0 0 0-4.42 3.623 9.83 9.83 0 0 0-1.65 5.465 9.8 9.8 0 0 0 2.88 6.955 9.8 9.8 0 0 0 6.95 2.881m0-18.613c1.73 0 3.43.513 4.86 1.474a8.8 8.8 0 0 1 3.23 3.927c.66 1.599.83 3.358.49 5.055a8.731 8.731 0 0 1-6.87 6.874c-1.7.337-3.46.164-5.06-.498a8.78 8.78 0 0 1-5.4-8.084c.01-2.32.93-4.544 2.57-6.184a8.74 8.74 0 0 1 6.18-2.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.97 116.715a7.49 7.49 0 0 0 6.92-4.62c.56-1.368.71-2.873.42-4.325a7.53 7.53 0 0 0-2.04-3.832 7.5 7.5 0 0 0-3.84-2.048 7.47 7.47 0 0 0-4.32.426 7.46 7.46 0 0 0-3.36 2.756 7.5 7.5 0 0 0-1.26 4.158c0 .983.19 1.957.57 2.865.37.909.92 1.734 1.62 2.429a7.483 7.483 0 0 0 5.29 2.191m0-13.908c1.27 0 2.5.375 3.56 1.078a6.37 6.37 0 0 1 2.35 2.87c.49 1.169.61 2.455.37 3.695a6.4 6.4 0 0 1-1.76 3.275 6.37 6.37 0 0 1-3.27 1.75 6.37 6.37 0 0 1-3.69-.364 6.38 6.38 0 0 1-2.87-2.355 6.34 6.34 0 0 1-1.08-3.553 6.39 6.39 0 0 1 6.39-6.396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.97 113.936c.94 0 1.86-.278 2.64-.799.77-.52 1.38-1.26 1.74-2.125.36-.866.45-1.818.27-2.737a4.67 4.67 0 0 0-1.3-2.425 4.7 4.7 0 0 0-2.42-1.297 4.75 4.75 0 0 0-2.74.27c-.86.358-1.6.965-2.12 1.744-.53.779-.8 1.695-.8 2.632 0 1.255.5 2.459 1.39 3.347a4.73 4.73 0 0 0 3.34 1.39m0-8.357c.73 0 1.43.214 2.03.615.6.402 1.07.972 1.35 1.639.27.667.34 1.401.2 2.109a3.6 3.6 0 0 1-1 1.869c-.51.51-1.16.858-1.86.999-.71.141-1.45.068-2.11-.208a3.668 3.668 0 0 1-2.26-3.372c.01-.968.39-1.894 1.08-2.578a3.65 3.65 0 0 1 2.57-1.073"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1306.97 100.064c1.95 0 3.85-.576 5.47-1.657a9.8 9.8 0 0 0 3.62-4.415c.75-1.797.94-3.775.56-5.683a9.9 9.9 0 0 0-2.69-5.037 9.86 9.86 0 0 0-5.04-2.692 9.83 9.83 0 0 0-5.68.56 9.9 9.9 0 0 0-4.42 3.623 9.84 9.84 0 0 0-1.65 5.465 9.81 9.81 0 0 0 2.88 6.955 9.81 9.81 0 0 0 6.95 2.881m0-18.613c1.73 0 3.43.513 4.86 1.474a8.8 8.8 0 0 1 3.23 3.927c.66 1.599.83 3.358.49 5.055a8.7 8.7 0 0 1-2.39 4.48 8.73 8.73 0 0 1-4.48 2.394c-1.7.337-3.46.164-5.06-.498a8.77 8.77 0 0 1-5.4-8.084c.01-2.32.93-4.544 2.57-6.184a8.74 8.74 0 0 1 6.18-2.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.97 97.715a7.49 7.49 0 0 0 6.92-4.62c.56-1.368.71-2.873.42-4.325a7.47 7.47 0 0 0-2.05-3.832 7.473 7.473 0 0 0-8.15-1.622 7.46 7.46 0 0 0-3.36 2.756 7.5 7.5 0 0 0-1.26 4.158c0 .983.19 1.957.57 2.865.37.909.92 1.734 1.62 2.429a7.4 7.4 0 0 0 2.43 1.622c.91.376 1.88.57 2.86.569m0-13.908c1.27 0 2.5.375 3.56 1.078a6.37 6.37 0 0 1 2.35 2.87c.49 1.169.61 2.455.36 3.695a6.3 6.3 0 0 1-1.75 3.275 6.37 6.37 0 0 1-3.27 1.75c-1.24.247-2.53.12-3.69-.364a6.45 6.45 0 0 1-2.88-2.355 6.4 6.4 0 0 1-1.07-3.553c0-1.696.67-3.322 1.87-4.522a6.4 6.4 0 0 1 4.52-1.874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.97 94.936c.94 0 1.86-.278 2.64-.799a4.747 4.747 0 0 0 2.01-4.862 4.67 4.67 0 0 0-1.3-2.425 4.7 4.7 0 0 0-2.42-1.297 4.75 4.75 0 0 0-2.74.27c-.86.358-1.6.965-2.12 1.744-.53.78-.8 1.695-.8 2.632 0 1.255.5 2.46 1.39 3.347a4.72 4.72 0 0 0 3.34 1.39m0-8.357c.73 0 1.43.214 2.03.615s1.07.972 1.35 1.639c.27.667.34 1.4.2 2.109a3.58 3.58 0 0 1-1 1.869c-.51.51-1.16.858-1.86.999-.71.14-1.45.068-2.11-.208a3.664 3.664 0 0 1-2.26-3.373c.01-.966.39-1.893 1.08-2.577a3.65 3.65 0 0 1 2.57-1.073"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.837 129.674a9.836 9.836 0 0 0 9.648-11.756 9.85 9.85 0 0 0-2.692-5.037A9.836 9.836 0 0 0 841 119.837a9.84 9.84 0 0 0 2.881 6.956 9.84 9.84 0 0 0 6.956 2.881m0-18.614a8.75 8.75 0 0 1 8.083 5.401 8.748 8.748 0 0 1-15.358 8.208 8.748 8.748 0 0 1 7.275-13.609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.836 127.324a7.483 7.483 0 0 0 1.46-14.825 7.48 7.48 0 0 0-7.683 3.183 7.48 7.48 0 0 0 .93 9.451 7.48 7.48 0 0 0 5.293 2.191m0-13.907a6.4 6.4 0 0 1 5.909 3.948 6.393 6.393 0 0 1-4.661 8.719 6.393 6.393 0 0 1-7.643-6.272 6.4 6.4 0 0 1 6.395-6.395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.838 124.545a4.74 4.74 0 0 0 4.376-2.924 4.74 4.74 0 0 0-3.452-6.458 4.74 4.74 0 0 0-4.863 2.014 4.74 4.74 0 0 0-.798 2.631 4.743 4.743 0 0 0 4.737 4.737m0-8.356a3.65 3.65 0 0 1 3.372 2.253 3.651 3.651 0 1 1-7.023 1.397 3.666 3.666 0 0 1 3.651-3.65"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.837 273.441a9.83 9.83 0 0 0-9.088 6.073 9.84 9.84 0 0 0 7.169 13.412 9.83 9.83 0 0 0 5.683-.56 9.83 9.83 0 0 0 6.073-9.088 9.83 9.83 0 0 0-2.882-6.955 9.83 9.83 0 0 0-6.955-2.882m0 18.614a8.75 8.75 0 0 1-8.083-5.401 8.753 8.753 0 0 1 6.376-11.929 8.75 8.75 0 0 1 8.982 3.721 8.75 8.75 0 0 1 1.474 4.861 8.75 8.75 0 0 1-8.749 8.748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.838 275.791a7.49 7.49 0 0 0-6.915 4.62 7.48 7.48 0 0 0 1.622 8.157 7.487 7.487 0 0 0 11.516-1.134 7.488 7.488 0 0 0-3.359-11.074 7.5 7.5 0 0 0-2.864-.569m0 13.908a6.397 6.397 0 0 1-4.523-10.918 6.4 6.4 0 0 1 6.97-1.386 6.4 6.4 0 0 1 3.948 5.908 6.4 6.4 0 0 1-6.395 6.396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.836 278.57a4.739 4.739 0 0 0-4.645 5.661 4.73 4.73 0 0 0 3.721 3.722 4.74 4.74 0 0 0 5.661-4.646 4.743 4.743 0 0 0-4.737-4.737m0 8.357a3.65 3.65 0 0 1-3.372-2.254 3.651 3.651 0 0 1 4.769-4.769 3.65 3.65 0 0 1 2.254 3.372 3.667 3.667 0 0 1-3.651 3.651"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.837 220.441a9.836 9.836 0 1 0 0 19.672 9.836 9.836 0 0 0 0-19.672m0 18.614a8.75 8.75 0 0 1-8.083-5.401 8.75 8.75 0 1 1 16.832-3.347 8.753 8.753 0 0 1-8.75 8.748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.838 222.791a7.49 7.49 0 0 0-6.915 4.62 7.487 7.487 0 0 0 5.454 10.205 7.48 7.48 0 0 0 7.684-3.182 7.485 7.485 0 0 0-6.223-11.643m0 13.908a6.393 6.393 0 0 1-6.273-7.643 6.397 6.397 0 0 1 8.72-4.661 6.4 6.4 0 0 1 3.948 5.908 6.4 6.4 0 0 1-6.395 6.396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.836 225.57a4.73 4.73 0 0 0-4.376 2.924 4.738 4.738 0 0 0 6.189 6.189 4.734 4.734 0 0 0 1.534-7.723 4.74 4.74 0 0 0-3.347-1.39m0 8.357a3.65 3.65 0 1 1 3.65-3.651 3.665 3.665 0 0 1-3.65 3.651"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1262.84 247.441c-1.95 0-3.85.577-5.47 1.658a9.8 9.8 0 0 0-3.62 4.415 9.8 9.8 0 0 0-.56 5.683 9.9 9.9 0 0 0 2.69 5.037 9.86 9.86 0 0 0 5.04 2.692c1.91.38 3.88.185 5.68-.56a9.9 9.9 0 0 0 4.42-3.623 9.83 9.83 0 0 0 1.65-5.465 9.8 9.8 0 0 0-2.88-6.955 9.81 9.81 0 0 0-6.95-2.882m0 18.614c-1.73 0-3.43-.513-4.86-1.474a8.8 8.8 0 0 1-3.23-3.927 8.74 8.74 0 0 1-.49-5.055 8.7 8.7 0 0 1 2.39-4.48 8.763 8.763 0 0 1 9.54-1.896 8.77 8.77 0 0 1 5.4 8.084 8.8 8.8 0 0 1-2.57 6.184 8.74 8.74 0 0 1-6.18 2.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.84 249.791a7.49 7.49 0 0 0-6.92 4.62 7.53 7.53 0 0 0-.42 4.325c.29 1.452 1 2.785 2.05 3.832a7.46 7.46 0 0 0 3.83 2.048c1.45.289 2.95.141 4.32-.426a7.46 7.46 0 0 0 3.36-2.756 7.5 7.5 0 0 0 1.26-4.158c0-.984-.19-1.957-.57-2.865a7.3 7.3 0 0 0-1.62-2.429 7.4 7.4 0 0 0-2.43-1.622 7.5 7.5 0 0 0-2.86-.569m0 13.908c-1.27 0-2.5-.375-3.56-1.078a6.37 6.37 0 0 1-2.35-2.87 6.3 6.3 0 0 1-.36-3.695c.24-1.241.85-2.38 1.75-3.275a6.37 6.37 0 0 1 3.27-1.75 6.37 6.37 0 0 1 3.69.364 6.46 6.46 0 0 1 2.88 2.355 6.4 6.4 0 0 1 1.07 3.553c0 1.696-.67 3.322-1.87 4.521a6.4 6.4 0 0 1-4.52 1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.84 252.57c-.94 0-1.86.278-2.64.799-.77.52-1.38 1.26-1.74 2.125a4.75 4.75 0 0 0-.27 2.737c.18.919.63 1.763 1.3 2.425.66.663 1.5 1.114 2.42 1.297s1.87.089 2.74-.27c.86-.358 1.6-.966 2.12-1.745.53-.778.8-1.694.8-2.631 0-1.256-.5-2.459-1.39-3.347a4.72 4.72 0 0 0-3.34-1.39m0 8.357a3.63 3.63 0 0 1-2.03-.616 3.7 3.7 0 0 1-1.35-1.638 3.7 3.7 0 0 1-.2-2.109 3.6 3.6 0 0 1 1-1.869c.51-.51 1.16-.858 1.86-.999a3.65 3.65 0 0 1 2.11.208 3.665 3.665 0 0 1 2.26 3.372 3.674 3.674 0 0 1-3.65 3.651"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1879.34 71.559c1.95 0 3.85-.577 5.47-1.658a9.9 9.9 0 0 0 3.62-4.415c.74-1.797.94-3.775.56-5.683a9.9 9.9 0 0 0-2.69-5.037 9.86 9.86 0 0 0-5.04-2.692 9.8 9.8 0 0 0-5.68.56 9.83 9.83 0 0 0-6.08 9.088c0 2.609 1.04 5.11 2.89 6.955a9.81 9.81 0 0 0 6.95 2.882m0-18.614c1.73 0 3.42.513 4.86 1.474a8.7 8.7 0 0 1 3.22 3.927c.67 1.599.84 3.358.5 5.055a8.8 8.8 0 0 1-2.39 4.48 8.76 8.76 0 0 1-4.48 2.394c-1.7.337-3.46.164-5.06-.498a8.7 8.7 0 0 1-3.92-3.223 8.77 8.77 0 0 1-1.48-4.86c0-2.32.93-4.545 2.57-6.185a8.74 8.74 0 0 1 6.18-2.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.34 69.209a7.49 7.49 0 0 0 6.92-4.62c.56-1.368.71-2.873.42-4.325a7.47 7.47 0 0 0-2.05-3.832 7.46 7.46 0 0 0-3.83-2.048 7.47 7.47 0 0 0-4.32.426 7.46 7.46 0 0 0-3.36 2.756 7.5 7.5 0 0 0-1.26 4.158c0 .984.19 1.957.56 2.865a7.5 7.5 0 0 0 1.63 2.43 7.4 7.4 0 0 0 2.43 1.621c.9.376 1.88.57 2.86.569m0-13.908c1.27 0 2.5.375 3.55 1.078a6.33 6.33 0 0 1 2.36 2.87 6.4 6.4 0 0 1 .36 3.695 6.3 6.3 0 0 1-1.75 3.275 6.37 6.37 0 0 1-3.27 1.75c-1.24.247-2.53.12-3.7-.364a6.43 6.43 0 0 1-2.87-2.355 6.4 6.4 0 0 1-1.07-3.553c0-1.696.67-3.322 1.87-4.521a6.4 6.4 0 0 1 4.52-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.34 66.43a4.751 4.751 0 0 0 4.38-2.924c.36-.866.45-1.818.27-2.737a4.74 4.74 0 0 0-1.3-2.425 4.7 4.7 0 0 0-2.42-1.297 4.75 4.75 0 0 0-4.87 2.015 4.73 4.73 0 0 0-.79 2.631c0 1.256.5 2.46 1.39 3.347a4.72 4.72 0 0 0 3.34 1.39m0-8.357c.72 0 1.43.215 2.03.616.6.4 1.07.97 1.34 1.638a3.65 3.65 0 1 1-7.02 1.397c.01-.967.39-1.894 1.07-2.578a3.7 3.7 0 0 1 2.58-1.073"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1405.34 42.559c1.95 0 3.85-.577 5.47-1.658a9.9 9.9 0 0 0 3.62-4.415c.74-1.797.94-3.775.56-5.683a9.9 9.9 0 0 0-2.69-5.037 9.86 9.86 0 0 0-5.04-2.692 9.8 9.8 0 0 0-5.68.56 9.83 9.83 0 0 0-6.08 9.088c0 2.609 1.04 5.11 2.89 6.956a9.81 9.81 0 0 0 6.95 2.88m0-18.614c1.73 0 3.42.513 4.86 1.474a8.7 8.7 0 0 1 3.22 3.927c.67 1.599.84 3.358.5 5.055a8.8 8.8 0 0 1-2.39 4.48 8.76 8.76 0 0 1-4.48 2.394c-1.7.337-3.46.164-5.06-.498a8.7 8.7 0 0 1-3.92-3.223 8.77 8.77 0 0 1-1.48-4.86c0-2.32.93-4.545 2.57-6.185a8.74 8.74 0 0 1 6.18-2.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.34 40.209a7.49 7.49 0 0 0 6.92-4.62c.56-1.368.71-2.873.42-4.325a7.47 7.47 0 0 0-2.05-3.832 7.46 7.46 0 0 0-3.83-2.048 7.47 7.47 0 0 0-4.32.426 7.46 7.46 0 0 0-3.36 2.756 7.5 7.5 0 0 0-1.26 4.159c0 .983.19 1.956.56 2.864a7.5 7.5 0 0 0 1.63 2.43 7.4 7.4 0 0 0 2.43 1.621c.9.376 1.88.57 2.86.569m0-13.908c1.27 0 2.5.375 3.55 1.078a6.33 6.33 0 0 1 2.36 2.87 6.4 6.4 0 0 1 .36 3.695 6.3 6.3 0 0 1-1.75 3.275 6.37 6.37 0 0 1-3.27 1.75c-1.24.247-2.53.12-3.7-.364a6.43 6.43 0 0 1-2.87-2.355 6.4 6.4 0 0 1-1.07-3.553 6.39 6.39 0 0 1 6.39-6.395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.34 37.43a4.751 4.751 0 0 0 4.38-2.924c.36-.866.45-1.818.27-2.737a4.747 4.747 0 0 0-3.72-3.722 4.74 4.74 0 0 0-4.87 2.014 4.76 4.76 0 0 0 .59 5.979c.89.888 2.1 1.388 3.35 1.39m0-8.357c.72 0 1.43.215 2.03.616.6.4 1.07.97 1.34 1.638a3.65 3.65 0 1 1-7.02 1.397c.01-.967.39-1.894 1.07-2.578a3.68 3.68 0 0 1 2.58-1.073"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M931.341 43.559a9.83 9.83 0 0 0 9.088-6.073 9.83 9.83 0 0 0-2.132-10.72 9.836 9.836 0 1 0-6.956 16.793m0-18.614a8.749 8.749 0 1 1-8.749 8.748 8.754 8.754 0 0 1 8.749-8.748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.341 41.209a7.484 7.484 0 1 0 0-14.969 7.484 7.484 0 0 0 0 14.969m0-13.908a6.395 6.395 0 1 1 0 12.79 6.395 6.395 0 0 1 0-12.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.342 38.43a4.738 4.738 0 1 0-4.737-4.737 4.744 4.744 0 0 0 4.737 4.737m0-8.357a3.65 3.65 0 1 1-3.65 3.65 3.66 3.66 0 0 1 3.65-3.65"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.341 30.559a9.83 9.83 0 0 0 9.088-6.073 9.83 9.83 0 0 0-2.132-10.72 9.836 9.836 0 1 0-6.956 16.793m0-18.614a8.749 8.749 0 1 1-8.749 8.748 8.754 8.754 0 0 1 8.749-8.748",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.341 28.209a7.484 7.484 0 1 0 0-14.969 7.484 7.484 0 0 0 0 14.969m0-13.908a6.395 6.395 0 1 1 0 12.79 6.395 6.395 0 0 1 0-12.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.342 25.43a4.738 4.738 0 1 0-4.737-4.737 4.744 4.744 0 0 0 4.737 4.737m0-8.357a3.65 3.65 0 1 1-3.65 3.65 3.66 3.66 0 0 1 3.65-3.65"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.8,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1086.78 150.006c1.5 0 2.96-.444 4.2-1.275a7.53 7.53 0 0 0 2.79-3.396c.57-1.383.72-2.904.43-4.372a7.54 7.54 0 0 0-2.07-3.874 7.6 7.6 0 0 0-3.87-2.071 7.6 7.6 0 0 0-4.38.43 7.586 7.586 0 0 0-4.67 6.991c0 2.007.8 3.932 2.22 5.351a7.56 7.56 0 0 0 5.35 2.216m0-14.318a6.74 6.74 0 0 1 6.22 4.154 6.74 6.74 0 0 1-1.46 7.335 6.7 6.7 0 0 1-3.45 1.841 6.73 6.73 0 0 1-6.91-2.862 6.735 6.735 0 0 1 .84-8.496 6.74 6.74 0 0 1 4.76-1.972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.78 148.197c1.14 0 2.25-.337 3.2-.97a5.77 5.77 0 0 0 2.45-5.91 5.8 5.8 0 0 0-1.58-2.948 5.73 5.73 0 0 0-2.95-1.576 5.74 5.74 0 0 0-3.32.328 5.83 5.83 0 0 0-2.59 2.12 5.752 5.752 0 0 0 .72 7.271c.53.535 1.17.959 1.87 1.248s1.44.438 2.2.437m0-10.698c.97 0 1.92.289 2.73.829a5 5 0 0 1 1.82 2.208 4.91 4.91 0 0 1-1.07 5.361 4.95 4.95 0 0 1-2.52 1.347 4.93 4.93 0 0 1-5.05-2.092 4.92 4.92 0 0 1-.83-2.733c0-1.305.52-2.556 1.44-3.478a4.93 4.93 0 0 1 3.48-1.442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.78 146.061c.72 0 1.43-.214 2.03-.615.59-.4 1.06-.969 1.34-1.635a3.6 3.6 0 0 0 .2-2.105 3.62 3.62 0 0 0-2.86-2.863 3.63 3.63 0 0 0-2.1.208c-.67.276-1.24.743-1.64 1.342a3.64 3.64 0 0 0-.61 2.024c0 .966.38 1.892 1.07 2.575a3.65 3.65 0 0 0 2.57 1.069m0-6.428c.56 0 1.1.164 1.56.473s.82.747 1.04 1.26a2.9 2.9 0 0 1 .16 1.622 2.84 2.84 0 0 1-.77 1.438c-.4.393-.9.66-1.44.769a2.8 2.8 0 0 1-2.88-1.194 2.8 2.8 0 0 1-.48-1.56c.01-.744.3-1.457.83-1.983a2.8 2.8 0 0 1 1.98-.825"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.8,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.567 178.133a7.568 7.568 0 1 0-.002-15.136 7.568 7.568 0 0 0 .002 15.136m0-14.318a6.727 6.727 0 0 1 6.6 8.043 6.723 6.723 0 0 1-5.288 5.287 6.73 6.73 0 1 1-1.312-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.566 176.324a5.755 5.755 0 0 0 4.071-9.828 5.758 5.758 0 1 0-4.071 9.828m0-10.698a4.918 4.918 0 0 1 4.825 5.879 4.91 4.91 0 0 1-3.865 3.865 4.92 4.92 0 0 1-5.879-4.824 4.92 4.92 0 0 1 4.919-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.567 174.188a3.643 3.643 0 1 0-3.643-3.644 3.65 3.65 0 0 0 3.643 3.644m0-6.428a2.808 2.808 0 1 1-2.808 2.807 2.82 2.82 0 0 1 2.808-2.807"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1078.37 185.382 11.86 11.379-16.33 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1083.48 203.787-11.86-11.381 16.33-4.296z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m633.369 212.382 11.858 11.379-16.328 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.48 230.787-11.856-11.381 16.328-4.296z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m828.589 35.311 11.858 11.38-16.328 4.298z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833.7 53.717-11.856-11.381 16.329-4.297z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m334.164 112.149 11.858 11.379-16.328 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.275 130.554-11.856-11.38 16.328-4.297z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1539.37 169.382 11.86 11.379-16.33 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1544.48 187.787-11.86-11.381 16.33-4.296z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1602.81 139.618-11.86-11.379 16.33-4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1597.7 121.213 11.85 11.381-16.32 4.296z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1128.81 120.618-11.86-11.379 16.33-4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1123.7 102.213 11.85 11.381-16.32 4.296z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m654.809 131.618-11.858-11.379 16.328-4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.699 113.213 11.855 11.381-16.328 4.296z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1223.9 270.13 11.86 11.379-16.33 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229.01 288.535-11.85-11.381 16.33-4.296z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m778.903 297.13 11.858 11.379-16.328 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784.014 315.535-11.856-11.381 16.329-4.296z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1640.16 2.15 11.86 11.378-16.33 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1645.27 20.555-11.85-11.381 16.33-4.297z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1684.9 254.13 11.86 11.379-16.33 4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1690.01 272.535-11.85-11.381 16.33-4.296z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1457.27 54.87-11.85-11.379 16.33-4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1452.16 36.465 11.86 11.38-16.33 4.297z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m983.275 35.87-11.858-11.379 16.328-4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.164 17.465 11.856 11.38-16.328 4.297z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0C341",
    fillOpacity: 0.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.275 46.87-11.858-11.379 16.328-4.299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.164 28.465 11.856 11.38-16.328 4.297z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1015.44 223.36 12.64 12.137-17.41 4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1020.89 242.991-12.65-12.14 17.42-4.583z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.436 250.352 12.648 12.137-17.417 4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.888 269.983-12.647-12.14 17.418-4.583z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.436 180.36 12.648 12.137-17.417 4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.888 199.991-12.647-12.14 17.418-4.583z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1486.71 178.293 12.65 12.138-17.42 4.585z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1492.16 197.924-12.65-12.139 17.42-4.583z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1665.74 101.64-12.65-12.137 17.42-4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1660.29 82.01 12.65 12.139-17.42 4.583z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1191.74 82.64-12.65-12.137 17.42-4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1186.29 63.01 12.65 12.139-17.42 4.583z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m717.742 93.64-12.648-12.137 17.417-4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.291 74.01 12.646 12.139-17.417 4.583z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#51309F",
    fillOpacity: 0.4,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m415.742 70.64-12.648-12.137 17.417-4.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.291 51.01 12.646 12.139-17.417 4.583z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1036.88 193.116 9.54 16.535-3.79 2.19-9.54-16.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1046.93 195.806 2.18 3.796-16.52 9.549-2.19-3.793z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "#8C91F7",
    fillOpacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m590.288 206.802 9.537 16.535-3.794 2.19-9.537-16.533z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.329 209.492 2.189 3.796-16.526 9.549-2.19-3.793z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1038.29 92.802 9.53 16.535-3.79 2.19-9.54-16.533z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1048.33 95.492 2.19 3.796-16.53 9.549-2.19-3.793z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1744.29 15.802 9.53 16.535-3.79 2.19-9.54-16.533z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1754.33 18.492 2.19 3.796-16.53 9.549-2.19-3.793z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1644.29 131.884-9.53-16.535 3.79-2.19 9.54 16.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1634.25 129.194-2.19-3.796 16.53-9.549 2.19 3.793z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1170.29 112.884-9.53-16.535 3.79-2.19 9.54 16.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.25 110.194-2.19-3.796 16.53-9.55 2.19 3.794z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m696.293 123.884-9.536-16.535 3.793-2.19 9.537 16.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m686.253 121.194-2.189-3.796 16.526-9.549 2.189 3.793z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m394.293 100.884-9.536-16.535 3.793-2.19 9.537 16.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.253 98.194-2.189-3.796 16.526-9.55 2.189 3.794z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1006.85 129.414 7.86 13.632-3.12 1.805-7.87-13.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1015.13 131.632 1.8 3.129-13.62 7.872-1.81-3.127z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m274.008 117.66 7.862 13.632-3.127 1.805-7.862-13.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.286 119.878 1.805 3.129-13.624 7.873-1.805-3.127z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1470.01 83.66 7.86 13.632-3.13 1.805-7.86-13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1478.29 85.878 1.8 3.13-13.62 7.872-1.81-3.127z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1674.33 195.586-7.86-13.632 3.12-1.805 7.86 13.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1666.05 193.368-1.81-3.129 13.63-7.872 1.8 3.127z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1200.33 176.586-7.86-13.632 3.12-1.805 7.86 13.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1192.05 174.368-1.81-3.129 13.63-7.872 1.8 3.127z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m726.327 187.586-7.862-13.632 3.127-1.805 7.863 13.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.049 185.368-1.805-3.129 13.624-7.872 1.806 3.127z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.086 70.709-7.861-13.632 3.127-1.805 7.862 13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.809 68.491-1.805-3.13 13.624-7.871 1.805 3.127z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2333",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m399.744 156.098-7.862-13.632 3.127-1.806 7.863 13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.466 153.88-1.805-3.13 13.624-7.872 1.806 3.127z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m865.752 262.126 9.375 16.255-3.729 2.153-9.376-16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875.623 264.77 2.152 3.732-16.246 9.388-2.153-3.729z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m420.752 279.126 9.375 16.255-3.729 2.153-9.376-16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.623 281.77 2.152 3.732-16.246 9.388-2.153-3.729z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.752 209.126 9.375 16.255-3.729 2.153-9.376-16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.623 211.77 2.152 3.732-16.246 9.388-2.153-3.729z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1326.75 236.126 9.38 16.255-3.73 2.153-9.38-16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1336.62 238.77 2.16 3.732-16.25 9.388-2.15-3.729z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1831.81 92.197-9.37-16.256 3.73-2.153 9.37 16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1821.94 89.552-2.15-3.732 16.24-9.387 2.16 3.729z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1341.43 53.874-9.38-16.255 3.73-2.153 9.38 16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1331.56 51.23-2.16-3.732 16.25-9.388 2.15 3.73z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m867.426 64.874-9.375-16.255 3.729-2.153 9.376 16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.555 62.23-2.152-3.732 16.246-9.388 2.153 3.73z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "#E68E34",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.812 26.197 561.436 9.94l3.729-2.153 9.376 16.253z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.941 23.552-2.153-3.732 16.247-9.387 2.153 3.729z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1066.41 268.46 6.33 10.987-2.52 1.455-6.33-10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1073.08 270.247 1.45 2.523-10.98 6.345-1.45-2.521z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m621.407 295.46 6.336 10.987-2.52 1.455-6.337-10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m628.079 297.247 1.455 2.523-10.981 6.345-1.455-2.521z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m274.407 225.46 6.336 10.987-2.52 1.455-6.337-10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.079 227.247 1.455 2.523-10.981 6.345-1.455-2.521z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1527.41 252.46 6.33 10.987-2.52 1.455-6.33-10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1534.08 254.247 1.45 2.523-10.98 6.345-1.45-2.521z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1614.77 56.54-6.34-10.987 2.53-1.455 6.33 10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1608.1 54.753-1.46-2.523 10.99-6.345 1.45 2.52z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1140.77 37.54-6.34-10.987 2.53-1.455 6.33 10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134.1 35.753-1.46-2.523 10.99-6.345 1.45 2.52z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m666.771 48.54-6.336-10.987 2.52-1.455 6.337 10.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.099 46.753-1.454-2.523 10.98-6.345 1.456 2.52z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "m364.771 25.54-6.336-10.987 2.52-1.455 6.337 10.985z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "m358.099 23.753-1.454-2.523 10.98-6.345 1.456 2.52z",
    clipRule: "evenodd"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m466.844 194.182 7.075 12.268-2.814 1.625-7.076-12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.293 196.178 1.624 2.816-12.26 7.085-1.625-2.814z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m158.407 132.594 7.076 12.268-2.815 1.625-7.076-12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.857 134.59 1.624 2.817-12.261 7.084-1.625-2.814z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1372.84 151.182 7.08 12.268-2.82 1.625-7.07-12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1380.29 153.178 1.63 2.816-12.26 7.085-1.63-2.814z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1769.33 157.818-7.07-12.268 2.81-1.625 7.08 12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1761.89 155.822-1.63-2.816 12.26-7.085 1.63 2.814z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1277.67 24.488-7.08-12.268 2.82-1.625 7.07 12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1270.22 22.492-1.62-2.817 12.26-7.084 1.62 2.814z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m821.334 149.818-7.075-12.268 2.814-1.625 7.076 12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813.885 147.822-1.624-2.816 12.261-7.085 1.624 2.814z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.094 32.94-7.076-12.267 2.815-1.625 7.075 12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.644 30.945-1.624-2.816 12.261-7.085 1.625 2.814z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F6964",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m527.669 150.488-7.075-12.268 2.814-1.625 7.076 12.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.219 148.492-1.624-2.816 12.261-7.085 1.625 2.814z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD149",
    d: "m1001.06 173.07 4.447 4.047-7.284 8.005-4.448-4.047zM556.064 200.07l3.698 3.365-7.285 8.005-3.698-3.365zM751.285 23l4.447 4.047-7.284 8.005L744 31.005zM209.064 130.07l3.698 3.365-7.285 8.005-3.698-3.365zM1470.28 129l4.447 4.047-7.284 8.005-4.448-4.047zM1680.11 151.93l-4.447-4.047 7.284-8.005 4.448 4.047zM1206.11 132.93l-4.447-4.047 7.284-8.005 4.448 4.047zM732.114 143.93l-4.447-4.047 7.284-8.005 4.448 4.047zM74.873 27.052l-4.447-4.047 7.285-8.004 4.447 4.047zM430.114 120.93l-3.698-3.365 7.285-8.005 3.698 3.365z",
    opacity: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E68E34",
    d: "m891.358 239.229 2.77 4.479-8.062 4.986-2.77-4.48zM446.358 266.229l2.63 4.252-8.062 4.986-2.63-4.252zM99.062 176l2.77 4.479-8.062 4.986-2.77-4.48zM1352.36 223.229l2.77 4.479-8.062 4.986-2.77-4.48zM1315.82 66.771l-2.77-4.478 8.062-4.986 2.77 4.478zM841.82 77.771l-2.77-4.478 8.062-4.986 2.77 4.478zM539.82 54.771l-2.77-4.478 8.062-4.986 2.77 4.478zM1003.61 282.805l-4.33 2.5-6.81-11.795 4.33-2.5zM558.612 309.805l-4.33 2.5-6.81-11.795 4.33-2.5zM211.612 239.805l-4.33 2.5-6.81-11.795 4.33-2.5zM1464.61 266.805l-4.33 2.5-6.81-11.795 4.33-2.5zM1677.57 42.195l4.33-2.5 6.81 11.795-4.33 2.5zM1203.57 23.195l6.553-3.783 6.81 11.795-6.553 3.783zM729.566 34.195l4.33-2.5 6.81 11.795-4.33 2.5z",
    opacity: 0.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E68E34",
    fillOpacity: 0.5,
    d: "m427.566 11.195 4.33-2.5 6.81 11.795-4.33 2.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3CDA6",
    d: "m495.609 184.869-4.724 1.637-4.46-12.869 4.724-1.637z",
    opacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E68E34",
    d: "m1723.21 163.703 4.724-1.637 4.46 12.869-4.724 1.637zM1249.21 144.703l4.724-1.637 4.46 12.869-4.724 1.637zM775.207 155.703l4.724-1.637 4.46 12.869-4.724 1.637zM115 66.478l4.724-1.637 4.46 12.869-4.724 1.637zM473.722 144.58l-2.5-4.33 11.795-6.81 2.5 4.33z",
    opacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5838C",
    d: "m861.708 221.568-4.846 1.231-3.354-13.2 4.846-1.232zM232.2 108.201l-4.846 1.231-3.354-13.2L228.846 95zM72.833 161.932l-1.294 4.83-13.156-3.525 1.294-4.83zM1322.71 195.568l-4.846 1.231-3.354-13.2 4.846-1.232zM1819.47 123.432l4.846-1.231 3.354 13.2-4.846 1.232zM1345.47 94.432l4.846-1.231 3.354 13.2-4.846 1.232zM891 105.863l4.846-1.231 3.354 13.2-4.846 1.232zM569.47 82.432l4.846-1.231 3.354 13.2-4.846 1.232z",
    opacity: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m933 182.309 1.294-4.83 13.156 3.525-1.294 4.83zM504.389 232.678l1.294-4.83 13.156 3.525-1.294 4.83zM1420.39 189.678l1.294-4.83 13.156 3.525-1.294 4.83zM1731.79 119.322l-1.294 4.83-13.156-3.525 1.294-4.83z",
    opacity: 0.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    fillOpacity: 0.8,
    d: "m1257.79 100.322-1.294 4.83-13.156-3.525 1.294-4.83z",
    opacity: 0.7
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m783.79 111.322-1.553 5.796-13.156-3.526 1.553-5.795zM481.79 88.322l-1.294 4.83-13.156-3.525 1.294-4.83z",
    opacity: 0.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m1063.94 155.645-3.76 3.295-8.976-10.244 3.76-3.295z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m285.736 164.244-3.76 3.295L273 157.295l3.76-3.295z",
    opacity: 0.8
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m1524.94 139.645-3.76 3.295-8.976-10.244 3.76-3.295zM1617.24 169.355l3.76-3.295 8.976 10.244-3.76 3.295z",
    opacity: 0.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m1143.24 150.355 3.76-3.295 8.976 10.244-3.76 3.295z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m669.241 161.355 3.76-3.295 8.976 10.244-3.76 3.295z",
    opacity: 0.7
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m12 44.478 3.76-3.295 8.976 10.244-3.76 3.295zM1094.5 252.777l-4.974.509-1.385-13.55 4.974-.508zM649.504 279.777l-4.974.509-1.385-13.55 4.974-.508z",
    opacity: 0.7
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m302.504 209.777-4.974.509-1.385-13.55 4.974-.508z",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m1555.5 236.777-4.974.509-1.385-13.55 4.974-.508zM1586.67 72.223l4.974-.509 1.386 13.55-4.975.508z",
    opacity: 0.7
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m1112.67 53.223 4.974-.509 1.386 13.55-4.975.508z",
    opacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CC8C",
    d: "m336.674 41.223 4.974-.509 1.386 13.55-4.975.508z",
    opacity: 0.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5838C",
    d: "m838.071 306-3.697-3.697 6.162-6.161 3.697 3.696zM46.07 253l-3.696-3.697 6.162-6.162 3.696 3.697zM1299.07 280l-3.697-3.697 6.162-6.161 3.697 3.696zM1843.11 39l3.697 3.697-6.162 6.161-3.697-3.696zM1369.11 20l3.697 3.697-6.162 6.161-3.697-3.696zM895.107 21l3.697 3.697-6.162 6.161-3.697-3.696zM1135.38 282.152l-5.35 5.35-9.631-9.63 5.35-5.35zM690.379 309.152l-3.536 3.536-9.63-9.631 3.535-3.536zM343.379 239.152l-3.536 3.536-9.63-9.631 3.535-3.536zM1596.38 266.152l-3.536 3.536-9.63-9.631 3.535-3.536zM1545.8 42.848l3.536-3.536 9.63 9.631-3.535 3.536zM1071.8 23.848l3.536-3.536 9.63 9.631-3.535 3.536z",
    opacity: 0.7
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m597.8 34.848 3.535-3.536 9.63 9.631-3.535 3.536z",
    opacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5838C",
    fillOpacity: 0.8,
    d: "m295.8 11.848 3.535-3.536 9.63 9.631-3.535 3.536z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m437.543 190.543-4.83-1.294 3.525-13.156 4.83 1.294zM77.83 117.449 73 116.155l3.525-13.156 4.83 1.294zM1798.63 161.457l4.83 1.294-3.525 13.156-4.83-1.294zM1324.63 142.457l7.31 1.958-3.526 13.156-7.31-1.958z",
    opacity: 0.7
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m850.635 153.457 5.796 1.553-3.526 13.156-5.795-1.553z",
    opacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C91F7",
    d: "m193.394 36.58 4.83 1.294-3.525 13.156-4.83-1.294zM562.525 154l4.83 1.294-3.525 13.156-4.83-1.294z",
    opacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 966.54,
    cy: 244.273,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.54,
    cy: 271.273,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.54,
    cy: 201.273,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1427.54,
    cy: 228.273,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1714.64,
    cy: 80.727,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 1714.64 80.727)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1240.64,
    cy: 61.727,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 1240.64 61.727)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.638,
    cy: 72.727,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 766.638 72.727)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.638,
    cy: 49.727,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 464.638 49.727)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.905,
    cy: 185.012,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.531,
    cy: 112.531,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1298.91,
    cy: 142.012,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1843.27,
    cy: 176.988,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 1843.27 176.988)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1488.53,
    cy: 11.531,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 1488.53 11.531)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 895.273,
    cy: 148.988,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 895.273 148.988)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.273,
    cy: 135.988,
    r: 3.531,
    fill: "#78CC8C",
    fillOpacity: 0.6,
    opacity: 0.7,
    transform: "rotate(180 593.273 135.988)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 974.107,
    cy: 161.039,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 529.107,
    cy: 188.039,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435.11,
    cy: 145.039,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1707.07,
    cy: 163.961,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7,
    transform: "rotate(180 1707.07 163.961)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1233.07,
    cy: 144.961,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7,
    transform: "rotate(180 1233.07 144.961)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.531,
    cy: 212.531,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7,
    transform: "rotate(180 740.531 212.531)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.831,
    cy: 39.084,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.7,
    transform: "rotate(180 101.831 39.084)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.072,
    cy: 132.961,
    r: 3.531,
    fill: "#E68E34",
    opacity: 0.4,
    transform: "rotate(180 457.072 132.961)"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1158.23 252.85c-1.49 0-2.96.443-4.2 1.275a7.5 7.5 0 0 0-2.79 3.396 7.6 7.6 0 0 0-.43 4.372 7.54 7.54 0 0 0 2.07 3.874 7.57 7.57 0 0 0 8.25 1.64 7.582 7.582 0 0 0 4.67-6.991c0-2.006-.8-3.931-2.22-5.35a7.56 7.56 0 0 0-5.35-2.216m0 14.318c-1.33 0-2.63-.395-3.74-1.134a6.8 6.8 0 0 1-2.48-3.021 6.736 6.736 0 0 1 1.46-7.334 6.74 6.74 0 0 1 7.34-1.459 6.723 6.723 0 0 1 4.15 6.218 6.73 6.73 0 0 1-6.73 6.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.23 254.658c-1.14 0-2.25.338-3.2.97a5.83 5.83 0 0 0-2.12 2.584 5.74 5.74 0 0 0-.32 3.327 5.77 5.77 0 0 0 1.57 2.948 5.77 5.77 0 0 0 6.28 1.248 5.75 5.75 0 0 0 2.58-2.121 5.745 5.745 0 0 0 .53-5.402 5.7 5.7 0 0 0-1.25-1.868 5.8 5.8 0 0 0-1.86-1.248 5.8 5.8 0 0 0-2.21-.438m0 10.698a4.915 4.915 0 0 1-4.54-3.036 4.86 4.86 0 0 1-.28-2.843c.19-.954.66-1.831 1.34-2.519a4.95 4.95 0 0 1 2.52-1.346c.96-.19 1.95-.092 2.84.28a4.915 4.915 0 0 1 3.04 4.545 4.93 4.93 0 0 1-1.44 3.478 4.9 4.9 0 0 1-3.48 1.441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.23 256.795c-.72 0-1.42.214-2.02.614s-1.07.969-1.35 1.635a3.7 3.7 0 0 0-.2 2.105c.14.707.49 1.356.99 1.866a3.65 3.65 0 0 0 3.98.79 3.644 3.644 0 0 0 2.24-3.367c0-.965-.38-1.891-1.06-2.574a3.67 3.67 0 0 0-2.58-1.069m0 6.428a2.794 2.794 0 0 1-2.59-1.734 2.73 2.73 0 0 1-.16-1.622 2.77 2.77 0 0 1 .77-1.438 2.795 2.795 0 0 1 3.06-.608c.51.212.95.572 1.26 1.034a2.795 2.795 0 0 1-.36 3.543 2.8 2.8 0 0 1-1.98.825"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.232 279.85a7.56 7.56 0 0 0-6.991 4.671 7.564 7.564 0 0 0 5.515 10.317 7.56 7.56 0 0 0 7.767-3.218 7.56 7.56 0 0 0-.941-9.554 7.57 7.57 0 0 0-5.35-2.216m0 14.318a6.735 6.735 0 0 1-6.218-4.155 6.73 6.73 0 1 1 6.218 4.155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.232 281.658a5.76 5.76 0 0 0-3.199.97 5.77 5.77 0 0 0-2.448 5.911 5.76 5.76 0 0 0 4.524 4.523 5.761 5.761 0 0 0 6.443-7.85 5.756 5.756 0 0 0-5.32-3.554m0 10.698a4.915 4.915 0 0 1-4.545-3.036 4.92 4.92 0 0 1 1.066-5.362 4.922 4.922 0 0 1 7.569.746 4.915 4.915 0 0 1-.612 6.211 4.92 4.92 0 0 1-3.478 1.441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.231 283.795a3.644 3.644 0 1 0 3.644 3.643 3.65 3.65 0 0 0-3.644-3.643m0 6.428a2.802 2.802 0 0 1-2.594-1.734 2.805 2.805 0 0 1 2.046-3.828 2.81 2.81 0 0 1 3.356 2.754 2.82 2.82 0 0 1-2.808 2.808"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.232 209.85a7.56 7.56 0 0 0-6.991 4.671 7.564 7.564 0 0 0 5.515 10.317 7.56 7.56 0 0 0 7.767-3.218 7.56 7.56 0 0 0-.941-9.554 7.57 7.57 0 0 0-5.35-2.216m0 14.318a6.735 6.735 0 0 1-6.218-4.155 6.73 6.73 0 1 1 6.218 4.155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.232 211.658a5.76 5.76 0 0 0-3.199.97 5.77 5.77 0 0 0-2.448 5.911 5.76 5.76 0 0 0 4.524 4.523 5.761 5.761 0 0 0 6.443-7.85 5.756 5.756 0 0 0-5.32-3.554m0 10.698a4.915 4.915 0 0 1-4.545-3.036 4.92 4.92 0 0 1 1.066-5.362 4.922 4.922 0 0 1 7.569.746 4.915 4.915 0 0 1-.612 6.211 4.92 4.92 0 0 1-3.478 1.441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.231 213.795a3.644 3.644 0 1 0 3.644 3.643 3.65 3.65 0 0 0-3.644-3.643m0 6.428a2.802 2.802 0 0 1-2.594-1.734 2.805 2.805 0 0 1 2.046-3.828 2.81 2.81 0 0 1 3.356 2.754 2.82 2.82 0 0 1-2.808 2.808"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1619.23 236.85c-1.49 0-2.96.443-4.2 1.275a7.5 7.5 0 0 0-2.79 3.396 7.6 7.6 0 0 0-.43 4.372 7.54 7.54 0 0 0 2.07 3.874 7.57 7.57 0 0 0 8.25 1.64 7.582 7.582 0 0 0 4.67-6.991c0-2.006-.8-3.931-2.22-5.35a7.56 7.56 0 0 0-5.35-2.216m0 14.318c-1.33 0-2.63-.395-3.74-1.134a6.8 6.8 0 0 1-2.48-3.021 6.736 6.736 0 0 1 1.46-7.334 6.74 6.74 0 0 1 7.34-1.459 6.723 6.723 0 0 1 4.15 6.218 6.73 6.73 0 0 1-6.73 6.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.23 238.658c-1.14 0-2.25.338-3.2.97a5.83 5.83 0 0 0-2.12 2.584 5.74 5.74 0 0 0-.32 3.327 5.77 5.77 0 0 0 1.57 2.948 5.77 5.77 0 0 0 6.28 1.248 5.75 5.75 0 0 0 2.58-2.121 5.745 5.745 0 0 0 .53-5.402 5.7 5.7 0 0 0-1.25-1.868 5.8 5.8 0 0 0-1.86-1.248 5.8 5.8 0 0 0-2.21-.438m0 10.698a4.915 4.915 0 0 1-4.54-3.036 4.86 4.86 0 0 1-.28-2.843c.19-.954.66-1.831 1.34-2.519a4.95 4.95 0 0 1 2.52-1.346c.96-.19 1.95-.092 2.84.28a4.915 4.915 0 0 1 3.04 4.545 4.93 4.93 0 0 1-1.44 3.478 4.9 4.9 0 0 1-3.48 1.441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.23 240.795c-.72 0-1.42.214-2.02.614s-1.07.969-1.35 1.635a3.7 3.7 0 0 0-.2 2.105c.14.707.49 1.356.99 1.866a3.65 3.65 0 0 0 3.98.79 3.644 3.644 0 0 0 2.24-3.367c0-.965-.38-1.891-1.06-2.574a3.67 3.67 0 0 0-2.58-1.069m0 6.428a2.794 2.794 0 0 1-2.59-1.734 2.73 2.73 0 0 1-.16-1.622 2.77 2.77 0 0 1 .77-1.438 2.795 2.795 0 0 1 3.06-.608c.51.212.95.572 1.26 1.034a2.795 2.795 0 0 1-.36 3.543 2.8 2.8 0 0 1-1.98.825"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1514.57 73.133a7.56 7.56 0 0 0 4.2-1.275 7.65 7.65 0 0 0 2.79-3.396c.57-1.383.72-2.904.43-4.372a7.54 7.54 0 0 0-2.07-3.875 7.58 7.58 0 0 0-8.25-1.64 7.64 7.64 0 0 0-3.4 2.787 7.573 7.573 0 0 0 6.3 11.77m0-14.318c1.33 0 2.63.394 3.74 1.134 1.1.74 1.96 1.79 2.47 3.02s.65 2.583.39 3.889a6.74 6.74 0 0 1-1.84 3.446 6.8 6.8 0 0 1-3.45 1.841 6.73 6.73 0 0 1-6.91-2.862 6.734 6.734 0 0 1 5.6-10.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.57 71.324a5.7 5.7 0 0 0 3.19-.97 5.8 5.8 0 0 0 2.13-2.584c.43-1.052.55-2.21.32-3.326a5.77 5.77 0 0 0-1.57-2.948 5.77 5.77 0 0 0-6.28-1.248 5.74 5.74 0 0 0-2.58 2.12 5.75 5.75 0 0 0-.53 5.402 5.8 5.8 0 0 0 1.24 1.869 5.774 5.774 0 0 0 4.08 1.685m0-10.698a4.92 4.92 0 0 1 4.54 3.037c.37.899.47 1.888.28 2.842a4.97 4.97 0 0 1-1.34 2.52 4.95 4.95 0 0 1-2.52 1.346c-.96.19-1.95.092-2.85-.28a4.9 4.9 0 0 1-2.2-1.812 4.93 4.93 0 0 1-.83-2.733c0-1.305.52-2.556 1.44-3.478a4.91 4.91 0 0 1 3.48-1.442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.57 69.188c.72 0 1.42-.214 2.02-.615.6-.4 1.07-.969 1.34-1.635.28-.666.35-1.398.21-2.105a3.656 3.656 0 0 0-2.86-2.863 3.66 3.66 0 0 0-2.11.208c-.66.276-1.23.742-1.63 1.342-.4.599-.62 1.303-.62 2.024.01.966.39 1.892 1.07 2.575a3.67 3.67 0 0 0 2.58 1.069m0-6.428a2.794 2.794 0 0 1 2.59 1.733c.21.513.27 1.078.16 1.622a2.77 2.77 0 0 1-.77 1.438 2.79 2.79 0 0 1-3.06.609 2.793 2.793 0 0 1-1.73-2.594c0-.744.3-1.457.82-1.983a2.83 2.83 0 0 1 1.99-.825"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1048.95 53.15a7.56 7.56 0 0 0 4.2-1.275 7.65 7.65 0 0 0 2.79-3.396c.57-1.382.72-2.904.43-4.372a7.54 7.54 0 0 0-2.07-3.874 7.58 7.58 0 0 0-8.25-1.64 7.64 7.64 0 0 0-3.4 2.787 7.573 7.573 0 0 0 6.3 11.77m0-14.318c1.33 0 2.63.395 3.74 1.134a6.76 6.76 0 0 1 2.47 3.02c.51 1.23.65 2.584.39 3.89a6.74 6.74 0 0 1-1.84 3.445 6.8 6.8 0 0 1-3.45 1.842 6.73 6.73 0 0 1-6.91-2.862 6.734 6.734 0 0 1 5.6-10.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.95 51.342a5.784 5.784 0 0 0 5.32-3.554c.43-1.052.55-2.21.32-3.327a5.77 5.77 0 0 0-1.57-2.948 5.77 5.77 0 0 0-6.28-1.248 5.74 5.74 0 0 0-2.58 2.12 5.75 5.75 0 0 0-.53 5.402 5.8 5.8 0 0 0 1.24 1.87c.54.534 1.17.958 1.87 1.248.7.289 1.45.437 2.21.437m0-10.698a4.92 4.92 0 0 1 4.82 5.879c-.19.954-.66 1.83-1.35 2.519a4.9 4.9 0 0 1-2.51 1.346c-.96.19-1.95.093-2.85-.28a4.9 4.9 0 0 1-2.2-1.812 4.93 4.93 0 0 1-.83-2.733c0-1.304.52-2.555 1.44-3.478a4.91 4.91 0 0 1 3.48-1.441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.95 49.205c.72 0 1.42-.214 2.02-.614s1.07-.97 1.34-1.635c.28-.666.35-1.399.21-2.105a3.656 3.656 0 0 0-2.86-2.863 3.66 3.66 0 0 0-2.11.207 3.66 3.66 0 0 0-1.63 1.342c-.4.6-.62 1.304-.62 2.025a3.7 3.7 0 0 0 1.07 2.574 3.67 3.67 0 0 0 2.58 1.07m0-6.428a2.794 2.794 0 0 1 2.59 1.733c.21.514.27 1.078.16 1.623a2.77 2.77 0 0 1-.77 1.438 2.79 2.79 0 0 1-3.06.608 2.793 2.793 0 0 1-1.73-2.594c0-.744.3-1.456.82-1.983a2.83 2.83 0 0 1 1.99-.825"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.567 22.133a7.565 7.565 0 0 0 7.421-9.043 7.57 7.57 0 0 0-10.317-5.515A7.56 7.56 0 0 0 791 14.566a7.567 7.567 0 0 0 7.567 7.567m0-14.318a6.73 6.73 0 1 1 0 13.46 6.73 6.73 0 0 1 0-13.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.566 20.324a5.758 5.758 0 1 0 0-11.517 5.758 5.758 0 0 0 0 11.517m0-10.698a4.92 4.92 0 0 1 4.545 3.037 4.91 4.91 0 0 1-1.066 5.361 4.921 4.921 0 0 1-8.398-3.479 4.92 4.92 0 0 1 4.919-4.919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.567 18.188a3.65 3.65 0 0 0 3.367-2.25 3.646 3.646 0 0 0-2.656-4.968 3.644 3.644 0 0 0-4.354 3.574 3.647 3.647 0 0 0 3.643 3.643m0-6.428a2.805 2.805 0 0 1 2.595 1.733 2.807 2.807 0 0 1-2.047 3.829 2.807 2.807 0 0 1-3.356-2.754 2.82 2.82 0 0 1 2.808-2.808"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    fill: "#78CC8C",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.946 41.15a7.565 7.565 0 0 0 7.422-9.043 7.57 7.57 0 0 0-10.317-5.514 7.56 7.56 0 0 0-4.671 6.99 7.567 7.567 0 0 0 7.566 7.567m0-14.318a6.73 6.73 0 0 1 6.218 4.155 6.72 6.72 0 0 1-1.459 7.334 6.73 6.73 0 0 1-7.334 1.459 6.73 6.73 0 0 1-4.155-6.218 6.737 6.737 0 0 1 6.73-6.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.946 39.342a5.758 5.758 0 1 0 0-11.516 5.758 5.758 0 0 0 0 11.516m0-10.698a4.919 4.919 0 1 1 0 9.837 4.919 4.919 0 0 1 0-9.837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.947 37.205a3.65 3.65 0 0 0 3.366-2.25 3.65 3.65 0 0 0-.789-3.97 3.646 3.646 0 0 0-5.606.552 3.64 3.64 0 0 0 .455 4.6 3.65 3.65 0 0 0 2.574 1.068m0-6.428a2.806 2.806 0 0 1 2.754 3.356 2.81 2.81 0 0 1-3.828 2.046 2.806 2.806 0 0 1-.908-4.577 2.82 2.82 0 0 1 1.982-.825"
  }))));
};
export default SvgConfettiBg;